import React from 'react'
import { Grid } from '@mui/material'
import { DatePicker, DateRangePicker } from 'rsuite';
import { Controller } from 'react-hook-form';
import Image from './Image';
import Images from 'assets/images';
import moment from 'moment';

const CalendarIcon = () => {
  return <Image src={Images.icon.calendar} />;
};

const InputMonthGrid = ({ xs, name, control, label, disabled, rules = {}, required }) => {
  return (
    <>
      <Grid
        item
        xs={xs}
        alignContent="center"
        justifyContent={"center"}
        style={{ width: '100%' }}
      >
        <Controller
          name={name}
          control={control}
          rules={!disabled && {
            ...rules,
            required
          }}
          render={({
            field: { value, onChange },
          }) => (
            <DatePicker
              oneTap
              format="yyyy-MM"
              renderValue={(date) => date ? moment(date).format('MMMM YYYY') : ''}
              // style={{ width: 200 }}
              style={{
                width: '100%',
                border: '1px solid #041C3F',
                borderRadius: '8px',
              }}
              caretAs={CalendarIcon}
              value={value}
              onChange={onChange}
              disabled={disabled}
            />
          )}
        />
      </Grid>
    </>
  )
}



export default InputMonthGrid